module.exports = "/images/vendor/flag-icon-css/flags/4x3/tf.svg?4ab43cc9db2814759ac2990c761f60a3";